import { CommonModule } from '@angular/common';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '@common/ui/material';
import { UiSharedComponentsModule } from '@common/ui/shared-components';

import { NotFoundPageComponent } from './pages/not-found-page/not-found-page.component';
import { FooterComponent } from './components/footer/footer.component';
import { MaintenanceModeModule } from '@common/ui/maintenance-mode';

@NgModule({
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  declarations: [NotFoundPageComponent, FooterComponent],
  imports: [
    CommonModule,
    RouterModule,
    MaterialModule,
    UiSharedComponentsModule,
    FormsModule,
    ReactiveFormsModule,
    MaintenanceModeModule,
  ],
  exports: [
    CommonModule,
    RouterModule,
    MaterialModule,
    UiSharedComponentsModule,
    NotFoundPageComponent,
    FooterComponent,
  ],
  providers: [],
})
export class SharedModule {}
